import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {Debugger} from "debug";
import {Autentisering} from "felles/tjenester/Autentisering";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {gettextCatalog} from "angular-gettext";
import {benyttetAutentiseringsmetodeSomStreng} from "felles/filter/benyttetAutentiseringsmetode";
import {Logger} from "../../../../../felles/infrastruktur/Logging";
import {Kontekst} from "../../../../../felles/tjenester/Kontekst";

const debug: Debugger = require('debug')('AktiverEidKontroller');
const css = require('./aktiverEid.scss');

export class AktiverEidKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmBrukerAktiverEid', {
              bindings: {
                  vedLukk: '&',
                  vedAutentisertCallback: '&vedAutentisert'
              },
              controller: AktiverEidKontroller.forInjisering(),
              template: require('./aktiverEid.html')
          });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            Kontekst.regNavn,
            Autentisering.regNavn,
            MeldingTilBruker.regNavn,
            Logger.regNavn,
            regNavn.gettext.gettextCatalog,
            AktiverEidKontroller
        ]
    }

    constructor(private $scope: IScope,
                private kontekst: Kontekst,
                private autentisering: Autentisering,
                private meldingTilBruker: MeldingTilBruker,
                private logger: Logger,
                private gettextCatalog: gettextCatalog) {
    }

    vedLukk: Function; //settes via bindings
    vedAutentisertCallback: (args: { autentisert: l.AutentisertOkModell }) => void; //satt via bindings

    steg: 'autentiser'|'alleredeBundet'|'binderbruker'|'kvittering' = 'autentiser';
    lagrer = false;
    valgtMetode: l.BenyttetAutentiseringsmetode;

    //brukt ved autentisering med criipto
    tokenvarighet = l.Tokenvarighet.kort;
    guiModus = l.CriiptoGuiModus.popup; //dersom vi velger noe annet enn popup må criipto callback håndteres på annet vis


    vedEidValgt(tilbyder: l.CriiptoIdTilbyder) {
        switch (tilbyder) {
            case l.CriiptoIdTilbyder.norsk_bankid_web_og_mobil:
                this.valgtMetode = l.BenyttetAutentiseringsmetode.bankidNorsk;
                break;
            case l.CriiptoIdTilbyder.svensk_bankid_samedevice:
            case l.CriiptoIdTilbyder.svensk_bankid_anotherdevice:
            case l.CriiptoIdTilbyder.svensk_bankid_anotherdeviceqr:
                this.valgtMetode = l.BenyttetAutentiseringsmetode.bankidSvensk;
                break;
        }
    }

    vedAutentisert(autentisert: l.AutentisertOkModell) {
        debug('autentisert', autentisert)
        this.steg = 'alleredeBundet';
        this.vedAutentisertCallback({autentisert: autentisert});
    }

    vedCriiptoBrukerIkkeFunnet(ukjentSubject: l.SubjectIdIkkeKnyttetTilBrukerModell){
        this.brukerIkkeBundetTilEId(ukjentSubject);
        this.steg = 'binderbruker';
    }

    vedCriiptoAvbrutt(){
        this.lukk();
    }

    vedCriiptoFeil(feil:any){
        debug('criiptoFeil', feil)
        this.logger.error(feil)
        this.meldingTilBruker.feilmelding(this.gettextCatalog.getString('En feil oppstod under autentisering med {{metode}}, vennligst prøv igjen', {metode: benyttetAutentiseringsmetodeSomStreng(this.valgtMetode, this.gettextCatalog)}))
        this.lukk();
    }

    lukk() {
       this.vedLukk();
    }

    $onInit(): void {
    }

    //private hjelpemetoder

    private brukerIkkeBundetTilEId(subjectInfo: l.SubjectIdIkkeKnyttetTilBrukerModell){
        debug('brukerIkkeBundetTilEId', subjectInfo)
        const spesifikasjon:l.CriiptoBindBrukerSpesifikasjon = {
            kryptertOpenIdIdentitet: subjectInfo.kryptertOpenIdIdentitet,
            tokenvarighet: this.kontekst.aktivtTokenInfo().tokenvarighet //henter varighet fra eksisterende innlogging
        }
        this.autentisering.bindAutentisertBrukerTilCriiptoSubject(spesifikasjon)
            .then(autentisert =>{
                debug('brukerIkkeBundetTilEId autentisert', autentisert)
                this.steg = 'kvittering';
                this.valgtMetode = subjectInfo.autentiseringsmetode;
                this.vedAutentisertCallback({autentisert: autentisert});
            })
            .catch(e => {
                //kryptert subject kan ha løpt ut på tid eller være ikke-dekrypterbar
                this.meldingTilBruker.feilmelding(this.gettextCatalog.getString('En feil oppstod under knytning av bruker med {{metode}}, vennligst prøv igjen', {metode: benyttetAutentiseringsmetodeSomStreng(this.valgtMetode, this.gettextCatalog)}))
                this.lukk();
            });
    }
}
